import Anchor from "../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import BaseSplashScreenMediator from "../../../../../shared/src/ranj/equalture/view/BaseSplashScreenMediator";
import FeedbackPanelView from "./FeedbackPanelView";


export default class SplashLoadScreenMediator extends BaseSplashScreenMediator {

    constructor(target, dispatcher, languagePack, layoutManager, startup, soundManager, config) {
        super(target, dispatcher, languagePack, layoutManager, startup, soundManager, config);
    }

    initialize() {
        super.initialize();

        this.startFeedback = new FeedbackPanelView(this._target.startFeedback);
        this.startFeedback.show(false);
        this.anchorObject(this._target.startFeedback, Anchor.B);
    }

    _handleStartButtonClick() {
        // Overrides default behaviour to show feedback panel instead of starting the game immediately. 
        // The racer game has a particularly heavy level buildup; the feedback was implemented to gracefully handle screen freezes during this buildup 
        // (so that the screen shows textual feedback during the freeze).
        this._buttonStartGame.visible = false;
        var text = this.getText("start.startFeedback");
        this.startFeedback.setText(this.getText("start.startFeedback"), false, false);
        this.startFeedback.show(true);
        this.callDelayed(this._start.bind(this), 200);
    }
}